// src/components/preferences/EditPreferenceModal.jsx
import React, { useState } from 'react';

const EditPreferenceModal = ({
    title,
    fromLabel,
    toLabel,
    fromValue,
    toValue,
    isOpen,
    onClose,
    onSubmit,
    compulsoryValue = false,
    onCompulsoryChange
}) => {
    const [from, setFrom] = useState(fromValue || '');
    const [to, setTo] = useState(toValue || '');
    const [compulsory, setCompulsory] = useState(compulsoryValue);

    const handleSubmit = () => {
        onSubmit({ from, to, compulsory });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
                <button onClick={onClose} className="absolute top-3 right-3 text-gray-600 hover:text-gray-800 text-xl">✖</button>
                <h2 className="text-lg font-bold mb-4">{title}</h2>

                <div className="mb-4">
                    <label className="block text-sm mb-1">{fromLabel}</label>
                    <input
                        type="number"
                        value={from}
                        onChange={(e) => setFrom(e.target.value)}
                        className="border rounded p-2 w-full"
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm mb-1">{toLabel}</label>
                    <input
                        type="number"
                        value={to}
                        onChange={(e) => setTo(e.target.value)}
                        className="border rounded p-2 w-full"
                    />
                </div>

                <div className="flex items-center mb-4">
                    <input
                        type="checkbox"
                        checked={compulsory}
                        onChange={(e) => {
                            setCompulsory(e.target.checked);
                            if (onCompulsoryChange) onCompulsoryChange(e.target.checked);
                        }}
                        className="mr-2"
                    />
                    <span className="text-sm">Mark as compulsory for exact matches</span>
                </div>

                <button
                    onClick={handleSubmit}
                    className="bg-orange-500 hover:bg-orange-600 text-white w-full py-2 rounded"
                >
                    SUBMIT
                </button>
            </div>
        </div>
    );
};

export default EditPreferenceModal;
